module.exports = __webpack_public_path__ + "img/import-portfolio-dark.2e1a70c.svg";